// extracted by mini-css-extract-plugin
module.exports = {"flex":"cardInfo_flex__vPGQB","row":"cardInfo_row__G7Jkd","container":"cardInfo_container__51Glh","info":"cardInfo_info__zpNQY","extraInfo":"cardInfo_extraInfo__lSrbp"};